const darkGreen = {
  10: '#1B423E',
  50: '#1D5B4F',
  100: '#20725F',
  200: '#259778',
}

export default darkGreen
